
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.908 26.116L38.462 1.17A1.64 1.64 0 0036.89 0H19.11a1.64 1.64 0 00-1.572 1.171L10.09 26.116a1.64 1.64 0 001.573 2.11h14.695V45.81c0 .043.003.086.007.129h-4.599a5.071 5.071 0 00-5.065 5.066v3.354c0 .906.734 1.641 1.64 1.641h19.315a1.64 1.64 0 001.641-1.64v-3.356a5.071 5.071 0 00-5.066-5.065h-4.598c.003-.043.006-.086.006-.13V28.227h5.684v8.98a1.64 1.64 0 003.28 0v-8.98h5.732a1.64 1.64 0 001.572-2.11zM34.233 49.22c.983 0 1.784.8 1.784 1.784v1.715H19.983v-1.715c0-.983.8-1.784 1.784-1.784h12.466zM13.866 24.944l6.466-21.663h15.336l6.466 21.663H13.866z","fill":"#6C7177"}})])
          )
        }
      }
    